var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropdownCheckboxes',{attrs:{"label":_vm.label,"name":_vm.name,"options":_vm.userOptions,"value":_vm.value,"loading":_vm.loading},on:{"input":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }